import { render } from "./YellowRegistrationSuccessful.vue?vue&type=template&id=a61254aa&scoped=true"
import script from "./YellowRegistrationSuccessful.vue?vue&type=script&lang=js"
export * from "./YellowRegistrationSuccessful.vue?vue&type=script&lang=js"

import "./YellowRegistrationSuccessful.vue?vue&type=style&index=0&id=a61254aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61254aa"]])

export default __exports__